import SelectMenu from "../Form/SelectMenu";
import { LABEL_CLASS, ERROR_CLASS, controlClass } from "./authFieldStyles";

// Select twin of AuthField, sized like the inputs beside it. The list always
// opens below the field, with a search box for long lists like countries.
const AuthSelect = ({
  name,
  label,
  placeholder = "Select...",
  options,
  value,
  error,
  onChange,
  onBlur,
  required = true,
}) => (
  <div>
    <label htmlFor={name} className={LABEL_CLASS}>
      {label} {required && <span className="text-danger-500">*</span>}
    </label>

    <SelectMenu
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      options={options}
      placeholder={placeholder}
      clearable={!required}
      className={`${controlClass(error)} pr-10`}
    />

    {error && <p className={ERROR_CLASS}>{error}</p>}
  </div>
);

export default AuthSelect;
